import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../../ui/atoms'

// TODO: Need to be changed with the data structure aka icons Array
function SocialShareButtons({ onClickHandler, icons }) {
  return (
    <div className="social-share-modal__buttons">
      <div className="socialshare-kwk">
        {icons.map(icon => {
          return (
            <>
              <div className="socialshare-kwk__icon">
                <Icon
                  key={icon[0]}
                  onClick={onClickHandler}
                  name={icon[0]}
                  viewBox="0 0 100 100"
                  className={`icoon icon--xxxlarge ${icon[0]}`}
                  data-testid={`socialshare-kwk-icon-${icon[0]}`}
                />
                <p className="socialshare-kwk__text">{icon[1]}</p>
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}

// FIXME: Duplicate (Step Two, Step Three) code needs to be extracted in a module
export default function StepOne({ onClick, channels, step }) {
  return (
    <div className={`${step === 1 ? '' : 'd-none'}`}>
      <div className="section-headline container py-0">
        <div className="section-headline__content">
          <div className="row col-12">
            <div className="section-headline__text-container col-12 text-center">
              <h2 className="section-headline__headline">Empfehlen Sie unser Angebot Ihren Freunden</h2>
              <div className="section-headline__subline">
                <strong>Schritt {step} von 3 </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <p className="mb-1">Teilen über:</p>
        <SocialShareButtons icons={channels} onClickHandler={onClick} />
        <a
          target="_blank"
          href="https://www.1und1.de/Datenschutz"
          className="link--dynamic link__text--gray text-center"
          rel="noreferrer"
          title="Hinweise zum Datenschutz"
        >
          <span className="link__text">
            <span>Hinweise zum Datenschutz!</span>
          </span>
        </a>
      </div>
    </div>
  )
}

StepOne.propTypes = {
  onClick: PropTypes.func,
  channels: PropTypes.arrayOf(PropTypes.array),
  step: PropTypes.number
}

SocialShareButtons.propTypes = {
  onClickHandler: PropTypes.func,
  icons: PropTypes.arrayOf(PropTypes.string)
}
